<script context="module">
  export function isNullOrUndefined(val) {
    return val === undefined || val == null;
  }
</script>